/**
 * Экран «мини-апп выключен» — партнёр снял тумблер в кабинете.
 *
 * Отдельный от `BotDisabledScreen` намеренно: тот говорит «продажи приостановлены
 * или аккаунт заблокирован», а здесь бот жив и продолжает продавать, просто через
 * чат. Показать вместо этого экран про блокировку — значит отправить человека
 * писать в поддержку по поводу, которого нет.
 */

import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { getWebApp } from '@/lib/telegram';

export function WebappDisabledScreen() {
  const { t } = useTranslation();

  const handleClose = () => {
    const tg = getWebApp();
    tg?.close();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 space-y-6">
      <div className="w-24 h-24 rounded-3xl bg-muted flex items-center justify-center">
        <MessageSquare className="w-12 h-12 text-muted-foreground" />
      </div>
      <div className="text-center space-y-2 max-w-sm">
        <h2 className="text-xl font-bold">{t('Webapp off title')}</h2>
        <p className="text-sm text-muted-foreground">{t('Webapp off description')}</p>
      </div>
      <button
        type="button"
        onClick={handleClose}
        className="px-6 py-3 bg-primary text-primary-foreground rounded-xl text-sm font-bold"
      >
        {t('Webapp off close')}
      </button>
    </div>
  );
}
